import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DashboardSummary } from './models/dashboard-summary.interface';
import { NgClass, NgTemplateOutlet, CurrencyPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-dashboard-summary',
    templateUrl: './dashboard-summary.component.html',
    styleUrls: ['./dashboard-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, MatIcon, NgTemplateOutlet, RouterLink, CurrencyPipe]
})
export class DashboardSummaryComponent {
    @Input() title: string;
    @Input() url: string;
    @Input() data: DashboardSummary[];
}
